import React from "react";
import { useProfile } from "../../../../context/ProfileContext";
import styles from "./profileComp.module.scss";
import Icon from "../../../../components/Icon";

const AboutMe = () => {
  const {
    profileInfo,
    handleFocus,
    current,
    handleChange,
    updatedField,
    handleDiscardData,
    handleSubmit,
    handleDiscard,
  } = useProfile();
   const getRole = () => {
     return localStorage.getItem("Role");
   };

  return (
    <div
      className={`${
        current?.section === "About"
          ? `${styles.editing}`
          : current?.section === ""
          ? `${styles.neutral} `
          : null
      } ${styles.InfoContainer}`}
    >
      <div className={styles.Header}>
        <h3>About Me</h3>

        {current?.section === "About" && (
          <div className={styles.headerStatus}>
            <Icon name="edit" width={15} height={15} className={styles.edits} />
            <p>editing</p>
          </div>
        )}
      </div>

      <div>
        <label htmlFor="Aboutme" className={styles.labels}>
          About me
        </label>
        <div className={styles.contBoxes}>
          <div className={styles.inputContainer}>
            <textarea
              id="aboutme"
              className={`${styles.basicInputs} ${
                updatedField?.fieldName === "me" ? styles.editingField : null
              }`}
              onChange={handleChange}
              name="aboutYou"
              value={profileInfo?.aboutYou}
              placeholder="About you"
              onFocus={() => {
                if (current?.fieldName === "") {
                  handleFocus("me", "About");
                  handleDiscardData("aboutYou");
                }
              }}
            />

            <div>
              <Icon name="edit" width={20} height={20} className={styles.edits} />
            </div>
          </div>
          {(current?.fieldName === "me" || updatedField?.fieldName === "me") && (
            <div className={styles.saves}>
              <button className={styles.save} onClick={(e: any) => handleSubmit(e, "aboutYou")}>
                Save
              </button>
              <button className={styles.discard} onClick={() => handleDiscard("aboutYou")}>
                Discard
              </button>
            </div>
          )}
        </div>
      </div>
      {getRole()?.toLocaleLowerCase() === "teacher" && (
        <div>
          <label htmlFor="aboutYouAsTeacher" className={styles.labels}>
            About me As a Teacher
          </label>
          <div className={styles.contBoxes}>
            <div className={styles.inputContainer}>
              <textarea
                id="aboutYouAsTeacher"
                className={`${styles.basicInputs} ${
                  updatedField?.fieldName === "aboutYouAsTeacher" ? styles.editingField : null
                }`}
                onChange={handleChange}
                name="aboutYouAsTeacher"
                value={profileInfo?.aboutYouAsTeacher}
                placeholder="About you"
                onFocus={() => {
                  if (current?.fieldName === "") {
                    handleFocus("aboutYouAsTeacher", "About");
                    handleDiscardData("aboutYouAsTeacher");
                  }
                }}
              />

              <div>
                <Icon name="edit" width={20} height={20} className={styles.edits} />
              </div>
            </div>
            {(current?.fieldName === "aboutYouAsTeacher" ||
              updatedField?.fieldName === "aboutYouAsTeacher") && (
              <div className={styles.saves}>
                <button
                  className={styles.save}
                  onClick={(e: any) => handleSubmit(e, "aboutYouAsTeacher")}
                >
                  Save
                </button>
                <button
                  className={styles.discard}
                  onClick={() => handleDiscard("aboutYouAsTeacher")}
                >
                  Discard
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default AboutMe;
